/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner } from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner';
import {
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerFromJSON,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerFromJSONTyped,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerToJSON,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerToJSONTyped,
} from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner';

/**
 * 
 * @export
 * @interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata
 */
export interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata {
    /**
     * 
     */
    related_document_information?: Array<MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner>;
    /**
     * Reason for the error (used with PROCESSING_ERROR type)
     */
    reason?: string;
    /**
     * Human-readable error message (used with PROCESSING_ERROR type)
     */
    message?: string;
}

/**
 * Check if a given object implements the MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata interface.
 */
export function instanceOfMatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata(value: object): value is MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata {
    return true;
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataFromJSON(json: any): MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata {
    return MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'related_document_information': json['related_document_information'] == null ? undefined : ((json['related_document_information'] as Array<any>).map(MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerFromJSON)),
        'reason': json['reason'] == null ? undefined : json['reason'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataToJSON(json: any): MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata {
    return MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataToJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataToJSONTyped(value?: MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'related_document_information': value['related_document_information'] == null ? undefined : ((value['related_document_information'] as Array<any>).map(MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerToJSON)),
        'reason': value['reason'],
        'message': value['message'],
    };
}

